/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {Address} from './Address';

/**
 * The Addresses model module.
 * @module model/Addresses
 * @version v1
 */
export class Addresses {
  /**
   * Constructs a new <code>Addresses</code>.
   * @alias module:model/Addresses
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>Addresses</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Addresses} obj Optional instance to populate.
   * @return {module:model/Addresses} The populated <code>Addresses</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Addresses();
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'String');
      if (data.hasOwnProperty('resources'))
        obj.resources = ApiClient.convertToType(data['resources'], [Address]);
    }
    return obj;
  }
}

/**
 * @member {String} status
 */
Addresses.prototype.status = undefined;

/**
 * @member {Array.<module:model/Address>} resources
 */
Addresses.prototype.resources = undefined;

